import { Component, computed, effect, Signal } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { AlertController, IonicModule } from '@ionic/angular';
import { iAppInfo } from './interfaces/app-info';
import { AppService } from './services/app.service';
import { AuthenticationService } from './services/authentication.service';
import { StorageService } from './services/storage.service';
import { environment } from 'src/environments/environment';
import { iUser } from './interfaces/user';


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        RouterLinkActive,
        RouterLink
    ],
})
export class AppComponent {

	public tourOperatorPages = [
		{
			title: 'Startside',
			url: '/tour-operator/overview',
			icon: 'home'
		},
		{
			title: 'Opret afgang',
			url: '/tour-operator/create-departure',
			icon: 'add-circle'
		},
		{
			title: 'Mine afgange',
			url: '/tour-operator/departures',
			icon: 'whale'
		},
		{
			title: 'Afgangsarkiv',
			url: '/tour-operator/archive',
			icon: 'archive'
		}
	];

	public tourConsultantPages = [
		{
			title: 'Book tur',
			url: '/tour-consultant/booking',
			icon: 'bag-outline'
		},
		{
			title: 'Ordreoversigt',
			url: '/tour-consultant/orders',
			icon: 'card-outline'
		},
		{
			title: 'Billetgrupper',
			url: '/tour-consultant/packs',
			icon: 'ticket-outline'
		},
		{
			title: 'Brugerprofil',
			url: '/profile',
			icon: 'person-circle-outline'
		}
	];

	public pages = []
	public ios: boolean
	public appInfo: iAppInfo = this.app.appInfo
	public appEnvVersion: string = environment.app_version

	public user: Signal<iUser> = computed(() => this.auth.user());
	public isDev: Signal<boolean> = computed(() => this.app.isDev());
	
	
	userData = effect(() => {
		if (this.user()) {
			const roles = this.auth.getUserRoles();
			if(roles.includes('tour_operator')) {
				this.pages = this.tourOperatorPages;
			}else {
				this.pages = this.tourConsultantPages;
			}
		}
	})


	constructor(
		public app: AppService,
		public auth: AuthenticationService,
		private storage: StorageService,
		private alertController: AlertController,
	) {
		// Wakeup call
		this.storage.wakeup()
		this.auth.getStoredUser()
		this.getInfo()
	}


	/**
	 * Show support alert with temporary support-information
	 */
	public async showSupportAlert() {
		const alert = await this.alertController.create({
			header: 'Brug for support?',
			message: 'Har du spørgsmål eller brug for hjælp til denne app, kontakt Arctic Excursions på tlf. ' + this.appInfo.contact_phone + ' eller e-mail ' + this.appInfo.contact_mail + '.',
			buttons: [
				{
					text: 'Ring op',
					handler: () => {
						window.open('tel:' + this.appInfo.contact_phone, '_self')
					}
				},
				{
					text: 'Send e-mail',
					handler: () => {
						window.open('mailto:' + this.appInfo.contact_mail, '_self')
					}
				},
				{
					text: 'Luk'
				}
			]
		})

		await alert.present();		
	}

	
	/**
	 * Get app info from API and update the local appInfo object
	 */
	public getInfo() {
		this.app.getAppInfo().subscribe({
			next: (response: iAppInfo) => {
				this.appInfo = response;

				// Update appInfo in service
				this.app.appInfo = response;

				if (this.appInfo?.info_message && this.appInfo.info_message !== '') {
					this.app.popMessage(null, this.appInfo.info_message);
				}
			},
			error: (error) => {
				// Use fallback appInfo from service
				this.appInfo = this.app.appInfo;

				this.app.popMessage('Error', error.message);
			}
		});
	}

}
